// react
import { useState } from 'react';

// i18n
import { useTranslation } from 'react-i18next';

// types
import { WorkPlan } from '../../../@types';

// dialogs
import { DialogActions } from '../DialogActions/DialogActions';

// forms
import { FormCreateWorkPlan } from '../../forms/FormCreateWorkPlan/FormCreateWorkPlan';

// Props

export interface DialogCreateWorkPlanProps {
	workPlan?: WorkPlan | null;
	isOpen: boolean;
	onClose: () => void;
	onSuccess: () => void;
}

// Component

export const DialogCreateWorkPlan = ({
	workPlan,
	isOpen,
	onClose,
	onSuccess,
}: DialogCreateWorkPlanProps) => {
	// hooks
	const { t } = useTranslation();

	// derived
	const isEditMode = Boolean(workPlan);

	// state
	const [isLoading, setIsLoading] = useState(false);

	return (
		<DialogActions
			actions={[
				{
					children: t('cancel'),
					onClick: onClose,
				},
				{
					children: isEditMode ? t('spendPlan.saveWorkPlan') : t('spendPlan.createWorkPlan'),
					form: isEditMode ? 'form-edit-work-plan' : 'form-create-work-plan',
					loading: isLoading,
					type: 'submit',
					variant: 'contained',
				},
			]}
			hasClose={true}
			isOpen={isOpen}
			maxWidth={800}
			onClose={onClose}
			title={{
				children: isEditMode ? t('spendPlan.editWorkPlan') : t('spendPlan.createNewWorkPlan'),
				variant: 'h3',
			}}>
			<FormCreateWorkPlan
				workPlan={workPlan}
				onClose={onClose}
				onSuccess={onSuccess}
				setIsLoading={setIsLoading}
			/>
		</DialogActions>
	);
};
